import { SocietyDirector } from 'types';

import { TranslateFn } from 'hooks/useTranslate';
import { hasInternalView } from 'utils/showDetails';

import councilTypes from 'modules/administratives/constants/councilTypes';
import councilAttendanceTypes from 'modules/administratives/constants/councilAttendanceTypes';
import { format } from 'date-fns';
import { DATE_FORMAT } from 'constants/defaultConstants';

type SelectOptions = {
  value: string;
  label: string;
};

const formatDirectorLabel = (director: SocietyDirector) =>
  hasInternalView()
    ? `${director?.socialDenomination} | ${director?.email} | ${
        director?.endDate
          ? format(new Date(director.endDate), DATE_FORMAT)
          : 'N/A'
      }`
    : `${director?.socialDenomination} | ${director?.email}`;

export const getSelectorOptions = (
  directors: SocietyDirector[],
  t: TranslateFn
) => {
  const attendanceOptions: SelectOptions[] = councilAttendanceTypes.map(
    (attendanceType) => ({
      value: attendanceType.value,
      label: t(attendanceType.label),
    })
  );

  const councilTypeOptions: SelectOptions[] = councilTypes.map(
    (councilType) => ({
      value: councilType.value,
      label: t(councilType.label),
    })
  );

  const directorOptions: SelectOptions[] = directors?.map(
    (director: SocietyDirector) => ({
      value: director._id as string,
      label: formatDirectorLabel(director),
    })
  );

  return {
    attendanceOptions,
    councilTypeOptions,
    directorOptions,
  };
};
